export const FLOW_CHOICE_TARGET = 'FlowChoice';

export const FLOW_CHOICE_OPTIONS = {
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
  START: 'manual'
};
